<script setup>

import { ref, watch, onMounted } from 'vue';

const { constante, selectionne } = defineProps({
  constante: Object,
  selectionne: Boolean
});

const composant = ref(null);

watch(() => selectionne, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

onMounted(() => {
	if (composant.value != null && selectionne) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

</script>

<template>
	<div class="constante" ref="composant">
		{{ constante.nom }}
	</div>
</template>

<style scoped>

.constante {
	overflow: hidden;
	text-overflow: ellipsis;
}

</style>